export default __webpack_public_path__ + "static/raj-8a80eaf9063435517980ed15f87cfb1c.jpg";